import LotusCardFrontImage from '../assets/images/LoyaltyCards/Golden-lotus-front.jpg';
import LotusCardBackImage from '../assets/images/LoyaltyCards/Golden-lotus-back.jpg';

export const LoyaltyCardsData = [
    // {
    //     id: 1,
    //     cardName: "Gold Card",
    //     description: "Gold Card.",
    //     alt: "Gold Card Image",
    //     frontImage: LoyaltyCardFrontImage,
    //     backImage: LoyaltyCardBackImage,
    //     inclusions: [
    //         {
    //             id: 1,
    //             title: "Qualify for a Stamp",
    //             description: "Receive a stamp when you purchase any treatment worth Rs. 9,000 or more."
    //         },
    //         {
    //             id: 2,
    //             title: "Exclusive Discounts",
    //             description: ""
    //         },
    //         {
    //             id: 3,
    //             title: "Pressure point stimulation",
    //             description: "Key pressure points on the head are stimulated to improve circulation, release tension, and enhance mental clarity."
    //         },
    //         {
    //             id: 4,
    //             title: "Relaxing head massage",
    //             description: "Gentle yet effective massage techniques are used to reduce stress, improve sleep, and strengthen hair."
    //         },
    //         {
    //             id: 5,
    //             title: "Shoulder Massage",
    //             description: "A soothing massage focused exclusively on the shoulders to relieve stiffness, reduce stress, and improve circulation."
    //         },
    //         {
    //             id: 6,
    //             title: "Hot Towel Treatment",
    //             description: "A warm towel is applied to the head, enhancing oil absorption, releasing tension, and leaving you feeling refreshed."
    //         },
    //     ],
    // },
    {
        id: 2,
        cardName: "Golden Lotus",
        description: "Your passport to indulgence, transformation, and well-deserved moments of bliss. Because you don't just visit — you bloom. 🌸",
        alt: "Lotus Card Image",
        frontImage: LotusCardFrontImage,
        backImage: LotusCardBackImage,
        inclusions: {
            english: [
                {
                    id: 1,
                    title: "Eligibility, Registration & 1'st Stamp",
                    description: `1.1 To be eligible for this promo, customers must first receive either the Panchakarma Welcome Ritual, normally priced at Rs. 22,100 and available at a special price of Rs. 9,900, or any other single treatment worth Rs. 9,900 after the discount.This offer is valid only for the first stamp on your Golden Lotus Card.

                    1.2 The loyalty card is non-transferable and valid only for the registered individual. Rewards and benefits cannot be claimed by anyone else.`
                },
                {
                    id: 2,
                    title: "Stamp Collection",
                    description: `2.1 A stamp is awarded for each individual service valued at Rs. 9,750 or more at Ceylon Hospital Wellness.

                    2.2 You must present your Golden Lotus Loyalty Card at each visit to receive a stamp.
                    
                    2.3 No card, no stamp.`
                },
                {
                    id: 3,
                    title: "Discounts & Rewards",
                    description: `3.1 Enjoy 30% off on your 2nd, 3rd, 4th, 6th, 7th, 8th, and 9th services.

                    3.2 Enjoy 50% off on your 5th service.

                    3.3 Collect 9 stamps and receive Rs. 22,750 OFF your 10th service. (This offer is non-refundable and non-transferable.)`
                },
                {
                    id: 4,
                    title: "Validity & Scope",
                    description: `4.1 The Golden Lotus Loyalty Card is valid for 12 months from the date of registration.

                    4.2 These terms and benefits are exclusive to the Golden Lotus Loyalty Card. They do not apply to any other loyalty cards issued by Ceylon Hospital Wellness.`
                },
            ],
            sinhala: [
                {
                    id: 1,
                    title: "සුදුසුකම්, ලියාපදිංචිය සහ පළමු මුද්‍රාව",
                    description: `1.1 මෙම ප්‍රවර්ධන වැඩසටහන සඳහා සුදුසුකම් ලැබීමට, ගනුදෙනුකරුවන් පළමුව සාමාන්‍ය මිල රු. 22,100ක් වන, සහ රු. 9,900 ක විශේෂ මිලකට ලබා ගත හැකි මෙම Panchakarma Welcome Ritual, හෝ වට්ටමෙන් පසු රු. 9,900 ක් වටිනා වෙනත් ඕනෑම තනි ප්‍රතිකාරයක් ලබා ගත යුතුය. මෙම දීමනාව ඔබගේ ගෝල්ඩන් ලෝටස් කාඩ්පතේ පළමු මුද්දරය සඳහා පමණක් වලංගු වේ.

                    1.2 ලෝයල්ටි කාඩ්පත වෙනත් කෙනෙකුට මාරු කළ නොහැකි අතර ලියාපදිංචි පුද්ගලයා සඳහා පමණක් වලංගු වේ. වෙනත් කිසිවෙකුට ත්‍යාග සහ ප්‍රතිලාභ හිමි නොවේ.`
                },
                {
                    id: 2,
                    title: "ස්ටැම්ප් එකතුව",
                    description: `2.1 සිලෝන් හොස්පිට්ල් වෙල්නස් හි රු. 9,750 හෝ ඊට වැඩි වටිනාකමක් ඇති සෑම සේවාවක් සඳහාම මුද්දරයක් ප්‍රදානය කෙරේ.

                    2.2 ස්ටැම්ප් ලබා ගැනීම සඳහා ඔබ සේවාව ලබා ගැනීමට ප්‍රථම ඔබේ ගෝල්ඩන් ලෝටස් ලෝයල්ටි කාඩ්පත ඉදිරිපත් කළ යුතුය.

                    2.3 ලෝයල්ටි කාඩ්පත ඉදිරිපත් නොකර ස්ටැම්ප් ලබා ගත නොහැක.`
                },
                {
                    id: 3,
                    title: "වට්ටම් සහ ප්‍රතිලාභ",
                    description: `3.1 ඔබගේ 2 වන, 3 වන, 4 වන, 6 වන, 7 වන, 8 වන සහ 9 වන සේවාවන් සඳහා 30% ක වට්ටමක් අත්වේ.
                    
                    3.2 ඔබගේ 5 වන සේවාව සඳහා 50% ක වට්ටමක් අත්වේ.
                    
                    3.3 ස්ටැම්ප් 9 ක් එකතු කර ඔබගේ 10 වන සේවාව සඳහා රු. 22,750 ක වට්ටමක් ලබා ගන්න. (මෙම දීමනාව මුදල් ලෙස මාරු කළ නොහැකි ය.)`
                },
                {
                    id: 4,
                    title: "වලංගුභාවය",
                    description: `4.1 ගෝල්ඩන් ලෝටස් ලෝයල්ටි කාඩ්පත ලියාපදිංචි කළ දින සිට මාස 12ක් සඳහා වලංගු වේ.
                    
                    4.2 මෙම නියමයන් සහ ප්‍රතිලාභ ගෝල්ඩන් ලෝටස් ලෝයල්ටි කාඩ්පතට පමණක් සීමා වේ. ඒවා සිලෝන් හොස්පිට්ල් වෙල්නස් විසින් නිකුත් කරන ලද වෙනත් කිසිදු ලෝයල්ටි කාඩ්පතකට අදාළ නොවේ.`
                },
            ],
        },
    },
]